import * as React from 'react';
import getLocationPhoto from '../actions/getLocationPhoto';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { LocationPersonaControlViewState } from '../data/schema/LocationPersonaControlViewState';
import { observer } from 'mobx-react';
import { Persona, PersonaPresence, PersonaSize } from 'office-ui-fabric-react/lib/Persona';

const assign = require('object-assign');

/**
 * props for the location persona control.
 * @param locationPersona: the persona control view state
 * @param size: the persona control size, this is passed to office-ui-fabric-react Persona control
 * @param showPersonaDetails: true if the contol show the persona text
 * @param className: a custom Css class passed to office-ui-fabric-react Persona control.
 */
export interface LocationPersonaControlProps {
    locationPersona: LocationPersonaControlViewState;
    size: PersonaSize;
    showPersonaDetails?: boolean;
    className?: string;
}

@observer
export class LocationPersonaControl extends React.Component<LocationPersonaControlProps, any> {
    componentDidMount() {
        this.fetchPersonaPhoto(this.props);
    }

    componentWillReceiveProps(nextProps: LocationPersonaControlProps) {
        this.fetchPersonaPhoto(nextProps);
    }

    shouldComponentUpdate(nextProps: LocationPersonaControlProps) {
        if (
            this.props.locationPersona.personaControlId ==
            nextProps.locationPersona.personaControlId
        ) {
            // If it's the same location persona, then we don't update the component
            return false;
        }

        return true;
    }

    /**
     * fetches the location persona photo
     * @param props the address and display text of the location
     */
    fetchPersonaPhoto(props: LocationPersonaControlProps) {
        if (
            props.locationPersona.postalAddress != null &&
            !isNullOrWhiteSpace(props.locationPersona.displayName)
        ) {
            getLocationPhoto(props.locationPersona);
        }
    }

    render() {
        let { locationPersona, className, size, showPersonaDetails } = this.props;

        if (locationPersona) {
            let photoDisplayProps: any = {};
            if (
                locationPersona.personaBlob &&
                locationPersona.personaBlob.blobUrl &&
                !isNullOrWhiteSpace(locationPersona.personaBlob.blobUrl)
            ) {
                assign(photoDisplayProps, {
                    imageUrl: locationPersona.personaBlob.blobUrl,
                    imageShouldFadeIn: false,
                });
            } else {
                assign(photoDisplayProps, {
                    imageInitials: locationPersona.initials,
                    initialsColor: locationPersona.textBoyColor,
                });
            }

            return (
                <Persona
                    className={className}
                    presence={PersonaPresence.none}
                    hidePersonaDetails={!showPersonaDetails}
                    size={size}
                    text={locationPersona.displayName}
                    secondaryText={locationPersona.displayAddress}
                    {...photoDisplayProps}
                />
            );
        }
        return null;
    }
}
